exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.block-content[data-v-99d2ac36] {\n    text-align: center;\n}\n", ""]);
